import { DialogController } from 'aurelia-dialog';
import { inject } from 'aurelia-framework';

@inject(DialogController)
export class ChargesDialog {
    dialogController;
    loading;
    item;

    constructor(dialogController) {
        this.dialogController = dialogController;
    }

    async activate(context) {
        this.item = context.item;
        this.charges = context.item.charges;

        this.undiscountedPrice = null;

        if (this.charges.length > 0 && this.item.itemPrice) {
            let itemPrice = {
                amount: this.item.itemPrice.amount,
                currency: this.item.itemPrice.currency,
            };

            for (let charge of this.charges) {
                itemPrice.amount -= charge.itemPrice.amount;
            }

            this.undiscountedPrice = itemPrice;
        }
    }
}
